import { easternMinutes } from "../server/station/windows";

/** The fields of a recorded dose a correction starts from. */
export interface CorrectedEntry {
  disposition: string;
  reason: string;
  amountGiven: string;
  givenAtUtc: string;
  administeredByEmail: string;
  prnReportedBy: string;
  notes: string;
}

/** An instant as the HH:MM an Eastern time input shows. */
export const easternHHMM = (iso: string) => {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return "";
  const m = easternMinutes(t);
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
};

/**
 * What a correction starts from (walk-through 2026-10-18): the entry being
 * corrected, every field but the reason for the correction, which stays
 * empty and required. Pure.
 */
export function correctionStart(a: CorrectedEntry, reasons: string[]) {
  const lateReason = a.reason.startsWith("Given late: ") ? a.reason.slice("Given late: ".length) : "";
  const listed = !lateReason && reasons.includes(a.reason);
  return {
    disposition: a.disposition,
    amount: a.amountGiven,
    time: easternHHMM(a.givenAtUtc),
    by: a.administeredByEmail,
    reason: listed ? a.reason : "",
    reasonText: !lateReason && !listed ? a.reason : "",
    late: lateReason,
    reportedBy: a.prnReportedBy,
    notes: a.notes,
  };
}

